<template>
<!-- 
  Author: lan.h
  Date: 2021-10-18
  content: 报告下载 
-->
  <div class="vb100">
    <div class="p_head">
      <div class="p_title">
        <p>REPORT</p>
        <h1>报告下载</h1>
      </div>
    </div>
    <div class="report-content" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.8)">
      <ul class="report-ul">
        <li v-for="item, index in report_list" :key="index">
          <div class="report_img">
            <img :src=" $store.state.img_req_url + item.logo_path" />
          </div>
          <div class="report-right">
            <a v-if="item.file_path" :href=" $store.state.img_req_url + item.file_path" target="_blank"><h1 class="over-p1">{{item.title}}</h1></a>
            <a v-else><h1 class="over-p1">{{item.title}}</h1></a>
            <p class="over-p2">{{item.summary}}</p>
            <div class="time">{{item.publish_time | time_deal}}</div>
          </div>
        </li>
      </ul>
      <div v-if="report_list.length == 0" class="empty">暂无数据</div>
    </div>
    <div class="layout-page" v-if="total > 10">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="params.page"
        :page-size="10"
        layout="prev, pager, next"
        :total="total">
      </el-pagination>
    </div>
    <div class="condition" v-if="is_condition">
      <div>
        <el-dropdown placement="top" @command="categoryChange" trigger="click">
          <span class="el-dropdown-link">
            {{params.category_id | dealNeed(report_type, 'name', '全部')}}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="''">全部</el-dropdown-item>
            <el-dropdown-item :command="item.id" v-for="item in  report_type" :key="item.id">{{item.name}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div>
        <el-dropdown placement="top" @command="tagChange" trigger="click">
          <span class="el-dropdown-link">
            {{params.tag_id | dealNeed(tag_list, 'name', '全部')}}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="''">全部</el-dropdown-item>
            <el-dropdown-item :command="item.id" v-for="item in  tag_list" :key="item.id">{{item.name}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <links></links>
  </div>
</template>
<script>
import { getReportTag, getReportList } from '@/service/main.js'
import links from 'mcomponents/mLinks.vue'
export default {
  data() {
    return {
      loading: false,
      report_type: [
        {id:'3', name:'百强企业成长报告'},
        {id:'5', name:'季度、年度投融资报告'},
        {id:'7', name:'细分领域研究报告'}
      ],
      params: {
        category_id: '',
        tag_id: '',
        page: 1
      },
      total: 0,
      report_list: [],
      tag_list: [],
      is_condition: true
    }
  },
  created() {
    this.getReportTag()
    // this.getReportList()
  },
  components: {links},
  mounted() {
    let _this = this
    this.$nextTick(() => {
      window.onscroll = () => {
        _this.listenerScroll()
      }
      window.onresize = () => {
        _this.listenerScroll()
      }
    })
  },
  beforeDestroy(){
    window.onscroll = null
    window.onresize = null
  },
  methods: {
    async getReportTag() {
      let res = await getReportTag({}, (error) => { this.$Message.error('请求错误') })
      if (res.status == 'success') {
        this.$set(this.$data, 'tag_list', res.res)
      } else {
        this.$Message.error(res.msg)
      }
    },
    async getReportList() {
      this.loading = true
      let res = await getReportList( this.params, (error) => { this.$Message.error('请求错误') })
      if (res.status == 'success') {
        this.$set(this.$data, 'report_list', res.res)
        this.total = res.count
        this.loading = false
      } else {
        this.$Message.error(res.msg)
      }
    },
    categoryChange(item) {
      this.params.category_id = item
      this.params.page = 1
      $("html,body").animate({ scrollTop: 0 }, 500);
      this.getReportList()
    },
    tagChange(val) {
      this.params.tag_id = val
      this.params.page = 1
      $("html,body").animate({ scrollTop: 0 }, 500);
      this.getReportList()
    },
    handleCurrentChange(val) {
      this.params.page = val
      $("html,body").animate({ scrollTop: 0 }, 500);
      this.getReportList()
    },
    listenerScroll() {
      let top = document.documentElement.scrollTop || document.body.scrollTop  //滚动条的值
      let vh = document.documentElement.clientHeight
      let footer = $('.footer').offset().top
      if(top >= footer - vh ){
        this.is_condition = false
      }else{
        this.is_condition = true
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~mcss/main/list.stylus';
.p_head
  margin 0 auto
  .p_links
    right 0
    .links-item
      height 30px
      .active
        color #326CDB
.report-content
  width calc(100% - 1.2rem)
  margin 0 auto
  min-height calc(100vh - 4.6rem)
  .report-ul
    li 
      width 100%
      display flex 
      flex-flow row wrap
      margin-top .4rem
      .report_img
        width 2.4rem
        height 1.44rem
        img 
          width 100%
          height 100%
      .report-right
        width calc(100% - 2.4rem)
        padding-left .2rem
        a
          display block
          height .25rem
          h1 
            font-size .26rem
            font-weight 800
            color #FFFFFF
            line-height .36rem
            cursor pointer
        p 
          font-size .24rem
          font-weight 500
          color #BCBDC1
          line-height .36rem
          margin-top .2rem
          height .7rem
        .time
          margin-top .1rem
          color #BCBDC1
          font-size .22rem
.condition
  width 100%
  height .95rem
  background #1F2330
  box-shadow 0px 2px 10px 0px rgba(14, 15, 20, 0.1)
  position fixed
  bottom 0
  left 0
  display flex
  >div 
    width 50%
    display flex 
    justify-content center
    align-items center
.vb100 
  padding-bottom .4rem
.empty
  width 100%
  height calc(100vh - 4.6rem)
  color #fff
  display flex
  align-items center
  justify-content center
</style>